module.exports = __webpack_public_path__ + "static/media/poll-people.e9312ec5.svg";